export default {
  policyEffectiveDate: 'تاريخ بدء الوثيقة',
  policyEffectiveDateRequired: 'تاريخ بدء الوثيقة مطلوب',
  yearsOfExperience: 'سنوات الخبرة',
  yearsOfExperienceRequired: 'سنوات الخبرة مطلوبة',
  regionOfPractice: 'منطقة الممارسة',
  regionOfPracticeRequired: 'منطقة الممارسة مطلوبة',
  placeOfPractice: 'جهة العمل',
  placeOfPracticeRequired: 'جهة العمل مطلوبة',
  specialty: 'التخصص',
  specialtyRequired: 'التخصص مطلوب',
  isPerformingSurgeries: 'هل تقوم بإجراء عمليات جراحية؟',
  isPerformingSurgeriesRequired:
    'يرجى تحديد ما إذا كنت تقوم بإجراء عمليات جراحية',
  continue: 'استمرار',
  previous: 'السابق',
  MMP_PlaceOfPracticeRequiredMsg:
    'يرجى اختيار جهة/جهات العمل، قد تطلب شركات التأمين أسماء هذه الجهات في خطوات لاحقة',
  missingSubSpecialty: 'تخصص اخر',
  missingSubSpecialtyRequired: 'التخصص الاخر مطلوب',
  noSpecialtiesFound: 'لا يوجد تخصصات متاحة',
  selectSpecialty: 'اختر التخصص',
} as const
